// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1Y6AM","insightsList":"newBusinessInsightsMenu_insightsList__3h2gu","active":"newBusinessInsightsMenu_active__1y8no"};